import { Component, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VerificationService } from '../../services/verification.service';
import { CustomEncodeDecodeService } from '../../../Common/services/custom-encode-decode.service';
import { ImageService } from '../../services/image.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from '../../../project-intake/services/message.service';
import { ValidationSummaryReportData } from '../../models/validationsummaryreportdata';

@Component({
  selector: 'app-project-info-header',
  templateUrl: './project-info-header.component.html',
  styleUrl: './project-info-header.component.css'
})
export class ProjectInfoHeaderComponent {
  projectId: number = 0;

  currentPage?: string;
  headerTitle?: string;
  imgURLforGalleryOrCard?: string;
  imgTitle?: string;

  projectTitle?: string;

  // totalImages?: number;
  // verifiedImages?: number;
  // outstandingImages?: number;

  inputValidationSummary?: ValidationSummaryReportData;
  isInputValidationSummaryLoaded: boolean = false;

  @Input() projectStatus?: string;
  @Input() isSaveResponseChanged?: number;
  @Input() isClearResponseChanged?: number;
  @Input() reviewedStores?: number;
  @Input() pendingStores?: number;
  @Input() vendorId?: number;  

  @Output() updateProjectVerificationStatus = new EventEmitter<number>();

  constructor(private route: ActivatedRoute, private router: Router,
    private imageService: ImageService, private verificationService: VerificationService,
    private encodeDecodeService: CustomEncodeDecodeService,
    private msgService: MessageService) { }

  ngOnInit() {

    //const projectIdParam = this.route.snapshot.paramMap.get('projectId');
    const projectIdParam = this.encodeDecodeService.decodeToInt(this.route.snapshot.paramMap.get('projectId'));
    if (projectIdParam !== null) {
      this.projectId = +projectIdParam;
    }
    else {
      this.projectId = 0;
    }

    this.verificationService.currentProjectTitle.subscribe(title => {
      if (title != '') {
        this.projectTitle = title;
      }
      else {
        this.projectTitle = localStorage.getItem('projectTitleForVerification')!;
      }
    });
    //this.verificationService.currentProjectTitle.subscribe(title => this.projectTitle = title);

    if (this.router.url.indexOf('ImageCard') > 0) {
      this.currentPage = "ImageCard";
      this.imgURLforGalleryOrCard = "assets/images/gallery_2.png";
      this.imgTitle = "Gallery";
      this.headerTitle = this.projectTitle;
    }
    else if (this.router.url.indexOf('ImageGallery') > 0) {
      this.currentPage = "ImageGallery";
      this.imgURLforGalleryOrCard = "assets/images/gallery.png";
      this.imgTitle = "By Store";
      this.headerTitle = this.projectTitle;
    }
    else {
      this.currentPage = "Dashboard";
      this.imgURLforGalleryOrCard = "";
      this.imgTitle = "";
      this.headerTitle = "VERIFICATION";
    }

    // if (this.currentPage !== "Dashboard") {
    //   this.getImagesCountInfo();
    // }
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['isSaveResponseChanged'] && changes['isSaveResponseChanged'].currentValue) {
  //     this.getImagesCountInfo();
  //   }
  //   if (changes['isClearResponseChanged'] && changes['isClearResponseChanged'].currentValue) {
  //     //alert('isClearResponseChanged');
  //     this.getImagesCountInfo();
  //   }
  // }

  navigateToPage() {
    if (this.currentPage == "ImageCard") {
      this.router.navigate(['/verification/ImageGallery', this.encodeDecodeService.encode(this.projectId)]);
    }
    if (this.currentPage == "ImageGallery") {
      this.router.navigate(['/verification/ImageCard', this.encodeDecodeService.encode(this.projectId)]);
    }
  }

  updateVerificationStatus() {
    this.updateProjectVerificationStatus.emit(this.projectId);
  }

  // getImagesCountInfo() {
  //   this.imageService.GetImagesCount(this.projectId)
  //     .pipe(
  //       catchError(error => {
  //         return of(); // Return an empty result to continue the stream
  //       })
  //     )
  //     .subscribe(imageCountData => {
  //       this.totalImages = imageCountData.totalImagesCount;
  //       this.verifiedImages = imageCountData.verifiedImagesCount;
  //       this.outstandingImages = imageCountData.pendingImagesCount;
  //     });
  // }

  generateValidationSummaryReport() {

    this.isInputValidationSummaryLoaded = true;
    this.inputValidationSummary = new ValidationSummaryReportData();
    this.inputValidationSummary.ProjectID = this.projectId;
    this.inputValidationSummary.ProjectTitle = this.headerTitle;
    this.inputValidationSummary.VendorID = this.vendorId;

    this.verificationService.GetValidationSummaryReport(this.inputValidationSummary).subscribe({
      next: (result) => {
        this.downloadFile(result);
        this.msgService.htmlSuccess('Successfully generated the Validation Summary Report');
        this.isInputValidationSummaryLoaded = false;
      },
      error: (err) => {
        this.msgService.htmlError('Failed to generate the Validation Summary Report');
        if (err.error) {
          console.error('Actual error message:', err.error.error);
        }
        this.isInputValidationSummaryLoaded = false;
      },
      complete: () => {
        this.isInputValidationSummaryLoaded = false;
      },
    })
  }


  downloadFile(blob: Blob): void {
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;

      const now = new Date();
      //const timestamp = now.toISOString().replace(/[:.-]/g, '').slice(0, 15); // 20250411T103015 
      //let reportFileName = `ProjectValidationSummary_${this.headerTitle}_${timestamp}`;
      let reportFileName = `ProjectValidationSummary_${this.headerTitle}`;
      a.download = `${reportFileName}.xlsx`;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  }

}